import { useNavigate } from "react-router-dom";
import CardSection from "../design/CardSection";

const FunLearningAlone = () => {
  const navigate = useNavigate();
  const goToComingSoon = () => {
    navigate("/fun_learning/comingsoon");
  };
  const raindropIntro = {
    title: "소나기",
    description: "떨어지는 비를 통한 즐거운 학습!",
    emoji: "🌧️",
    listItems: [
      "떨어지는 단어를 빠르게 맞추세요!",
      "반복을 통해 단어를 암기하세요!",
      "점수를 높여 기록을 경신하세요!",
      "반복학습으로 단어를 복습하세요!",
      "친구들과 경쟁하며 재미있게 학습하세요!",
    ],
    buttonText: "소나기 학습 시작하기",
    onClick: goToComingSoon,
  };

  const fishingGameInfo = {
    title: "물고기 잡기",
    description: "물고기 잡으며 어휘력을 키우세요!",
    emoji: "🐟",
    listItems: [
      "빠르게 단어를 맞추어 물고기를 잡으세요!",
      "점수를 높여 기록을 경신하세요!",
      "다양한 물고기를 수집하세요!",
      "어려운 단어를 배우며 실력을 향상시키세요!",
      "친구들과 경쟁하며 재미있게 학습하세요!",
    ],
    buttonText: "물고기 잡기 시작하기",
    onClick: goToComingSoon,
  };

  const cardFlipGameInfo = {
    title: "카드 뒤집기",
    description: "카드를 뒤집으며 단어를 학습해 보세요!",
    emoji: "🃏",
    listItems: [
      "카드를 뒤집어 일치하는 단어를 찾으세요!",
      "기억력을 향상시키며 학습하세요!",
      "다양한 단어를 배우며 어휘력을 키우세요!",
      "점수를 높여 기록을 경신하세요!",
      "친구들과 경쟁하며 재미있게 학습하세요!",
    ],
    buttonText: "카드 뒤집기 시작하기",
    onClick: goToComingSoon,
  };

  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            보카를 공부하는 가장 재미있는 방법!
          </h2>
          <p className="mb-5 font-light text-gray-500 sm:text-xl dark:text-gray-400">
            즐거운 학습을 선택하세요
          </p>
        </div>
        <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0">
          <CardSection {...raindropIntro} />
          <CardSection {...fishingGameInfo} />
          <CardSection {...cardFlipGameInfo} />
        </div>
      </div>
    </section>
  );
};
export default FunLearningAlone;
